<template>
  <div class="mt-8">
    <div class="markdown-wrapper text-sm sm:text-base">
      <slot name="story"></slot>
    </div>
  </div>
</template>
